import React, { useState } from "react";
import PageHeader from "../components/page-header";
import { Link } from "react-router-dom";
import AggregationWithApi from "../assets/images/aggregation-with-api.png";
import ApiIntegrationProcess from "../assets/images/travelcarma-api-integration-process.png";
import SuppliersHotel from "../components/suppliers-hotel";
import SuppliersFlight from "../components/suppliers-flight";
import SuppliersActivity from "../components/suppliers-activity";
import SuppliersCar from "../components/suppliers-car";

const ApiTravelXmlApiIntegrations = () => {
  const [activeTab, setActive] = useState("tab1");
  return (
    <div className="page-inside">
      <PageHeader page="travel-xml-api-integrations" />
      <div className="container">
        <div className="row">
          <div className="col-lg-6 text-center">
            <img
              src={AggregationWithApi}
              alt="API Integration"
              className="w-100"
              style={{ maxWidth: "412px" }}
            />
          </div>
          <div className="col-lg-6 text-justify">
            <p style={{ fontSize: "1.1rem", lineHeight: "28px" }}>
              85+ suppliers integrated—we manage integration complexity for you. Enterprise integration options: managed service (we handle it), custom connectors (built to your spec), or API-first architecture (extend without replacement). Deep relationships with GDS, NDC providers, and consolidators mean ongoing support, not just one-time integration.
            </p>

            <Link to="/contact-us" className="btn btn-primary">
              Request a Demo
            </Link>
          </div>
        </div>

        <div className="mt-5">
          <ul className="nav nav-tabs mt-5" style={{ marginBottom: "-28px" }}>
            <li className="nav-item">
              <button
                className={"nav-link " + (activeTab === "tab1" ? "active" : "")}
                onClick={() => setActive("tab1")}
              >
                Hotel
              </button>
            </li>
            <li className="nav-item">
              <button
                className={"nav-link " + (activeTab === "tab2" ? "active" : "")}
                onClick={() => setActive("tab2")}
              >
                Flight
              </button>
            </li>
            <li className="nav-item">
              <button
                className={"nav-link " + (activeTab === "tab3" ? "active" : "")}
                onClick={() => setActive("tab3")}
              >
                Activity
              </button>
            </li>
            <li className="nav-item">
              <button
                className={"nav-link " + (activeTab === "tab4" ? "active" : "")}
                onClick={() => setActive("tab4")}
              >
                Transfers
              </button>
            </li>
          </ul>

          {activeTab === "tab1" && <SuppliersHotel />}
          {activeTab === "tab2" && <SuppliersFlight />}
          {activeTab === "tab3" && <SuppliersActivity />}
          {activeTab === "tab4" && <SuppliersCar />}
        </div>
        <br />
        <br />

        <h2 className="text-center mt-5">Our API Integration Process</h2>
        <div className="text-center mt-5">
          <img
            src={ApiIntegrationProcess}
            alt="API Integration Process"
            className="w-100"
            style={{ maxWidth: "1000px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default ApiTravelXmlApiIntegrations;
